<div class="main-container clarichat clari-video-chat" id="brandingClariVideoChat">
  <div class="top-bar d-flex justify-content-between align-items-center">
    <div class="top-bar-actions">
    </div>
    <div class="top-bar-actions top-bar-actions-right">
      <!-- <button
        type="button"
        class="top-bar-settings-btn"
        aria-label="Settings">
        <mat-icon svgIcon="settings"></mat-icon>
      </button> -->
    </div>
  </div>

  <div class="messages-container" #messagesContainer>

    <!-- Pinned Navigation (same UX as ClariChat) -->
    <div class="pinned-nav-top-right" *ngIf="context.pinnedMessages.length > 0">
      <div class="pin-stack-anchor">
        <button class="arrow prev" type="button" (click)="context.scrollToPinned(false); $event.stopPropagation()">
          <i class="fas fa-arrow-up"></i>
        </button>

        <button class="arrow next" type="button" (click)="context.scrollToPinned(true); $event.stopPropagation()">
          <i class="fas fa-arrow-down"></i>
        </button>

        <button type="button" class="pin-stack-pill" aria-label="Pinned messages" (click)="context.togglePinStack($event)">
          📌 {{ context.pinnedMessages.length }} pinned
        </button>

        <button type="button" class="pin-clear-btn" aria-label="Clear all pinned messages" (click)="context.clearAllPins($event)">
          <i class="fas fa-xmark"></i>
        </button>

        <div class="pin-stack-preview" *ngIf="context.showPinStack" (click)="$event.stopPropagation()">
          <div class="pin-stack-title">📌 {{ context.pinnedMessages.length }} pinned</div>

          <button
            type="button"
            class="pin-stack-item"
            *ngFor="let pm of context.pinnedMessages; trackBy: context.trackMsg"
            (click)="context.jumpToPinned(pm.id); $event.stopPropagation()">
            <div class="pin-stack-snippet">
              {{ pm.content || '[no text]' }}
            </div>
            <div class="pin-stack-meta">
              {{ pm.modelDisplayName || pm.modelId || '' }}
              <span *ngIf="pm.timestamp">• {{ pm.timestamp | date:'short' }}</span>
            </div>
          </button>
        </div>
      </div>
    </div>

    <!-- Placeholder (ClariChat-style wrapper) -->
    <div class="chat-placeholder-grid-container" *ngIf="context.currentMessages.length === 0 && !context.isLoading" [class.model-menu-open]="context.dropdownOpen">
      <div class="placeholder-wrapper" id="placeholderNavArrows">
        <button
          *ngIf="!context.isTourActive || context.tourStepId === 'placeholderNavArrows'"
          class="placeholder-nav-arrow placeholder-nav-arrow-left"
          (click)="context.fastForwardTransition()"
          aria-label="Previous model">
          <i class="fas fa-chevron-left"></i>
        </button>

        <div class="placeholder-content">
          <img
            [src]="context.currentLogo"
            class="grid-item-logo vendor-logo"
            [class.fading]="context.logoFading"
          />

          <h1 class="placeholder-title" [class.fading]="context.modelNameFading">
            <span [class]="context.modelNameClass"
                  style="direction:ltr; unicode-bidi:isolate; display:inline-block; white-space:nowrap;">
              <span
                *ngFor="let letter of context.modelNameLetters; let i = index; trackBy: context.trackByLetter"
                class="model-name-letter"
                [class.waving]="context.isLetterWaving(i)"
                [class.dissolving]="context.modelNameFading"
                [style.color]="context.getLetterColor(i)"
                [style.--letter-index]="i">
                {{ letter.char === ' ' ? '\u00A0' : letter.char }}
              </span>
            </span>
          </h1>

          <h1 class="placeholder-subtitle bigal-sub" [class.fading]="context.logoFading">
            {{ context.currentPlaceholder }}
          </h1>
        </div>

        <button
          *ngIf="!context.isTourActive || context.tourStepId === 'placeholderNavArrows'"
          class="placeholder-nav-arrow placeholder-nav-arrow-right"
          (click)="context.fastForwardTransition()"
          aria-label="Next model">
          <i class="fas fa-chevron-right"></i>
        </button>
      </div>
    </div>

    <!-- Messages -->
    <ng-container *ngFor="let msg of context.currentMessages; let i = index; trackBy: context.trackMsg">
      <div
        class="message"
        [id]="'msg-' + msg.id"
        [ngClass]="{'user-message': msg.role === 'user', 'assistant-message': msg.role === 'assistant'}">

        <!-- Pin Buttons -->
        <button
          *ngIf="!msg.pinned"
          type="button"
          class="pin-corner-btn"
          (click)="context.togglePinMessage(msg)"
          [attr.aria-pressed]="msg.pinned"
          [attr.title]="msg.pinned ? 'Unpin message' : 'Pin message'">
          <img src="assets/svg/pin.svg" height="25px" />
        </button>

        <button
          *ngIf="msg.pinned"
          type="button"
          class="pin-corner-btn"
          (click)="context.togglePinMessage(msg)"
          [attr.aria-pressed]="msg.pinned"
          [attr.title]="msg.pinned ? 'Unpin message' : 'Pin message'">
          <i class="fa-thumbtack" [ngClass]="{'fa-solid pinned': msg.pinned}"></i>
        </button>

        <!-- Text / Markdown -->
        <div
          *ngIf="context.getMessageDisplayContent(msg) as content"
          class="markdown prism-content"
          [innerHTML]="context.convertMarkdown(content)"
          appCodeHighlight>
        </div>

        <!-- Unified Media Renderer -->
        <ng-container *ngIf="context.getImageUrls(msg) as imgs">
          <!-- DALL·E bucket (kept for style parity) -->
          <div *ngIf="imgs.length > 0 && context.isDalleMessage(msg)" class="dalle-image">
            <img [src]="imgs[0]" class="dalle-img" alt="Generated image" />
            <div *ngIf="imgs.length > 1" class="dalle-variants">
              <img
                *ngFor="let img of imgs; let imgIndex = index; trackBy: context.trackByMedia"
                [src]="img"
                class="dalle-img variant"
                [alt]="'Generated image variant ' + (imgIndex + 1)" />
            </div>
          </div>

          <!-- Stability: single image, 80% width, centered -->
          <div *ngIf="imgs.length > 0 && !context.isDalleMessage(msg) && context.isStabilityMessage(msg)" class="image-result stability-image">
            <img
              [src]="imgs[0]"
              class="stability-image__item"
              alt="Generated image" />
          </div>

          <!-- Generic image bucket (Grok Image, Google Image/Imagen, etc.) -->
          <div *ngIf="imgs.length > 0 && !context.isDalleMessage(msg) && !context.isStabilityMessage(msg)" class="image-result">
            <div class="image-result__variants">
              <img
                *ngFor="let img of imgs; trackBy: context.trackByMedia"
                [src]="img"
                class="image-result__item"
                alt="Generated image" />
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="context.getVideoUrls(msg) as vids">
          <!-- Video bucket (multi-model) -->
          <div *ngIf="vids.length > 0 || context.isVideoLike(msg)" class="video-message">
            <ng-container *ngIf="context.getThumbnailUrl(msg) as thumb">
              <img *ngIf="thumb && vids.length === 0" [src]="thumb" class="video-thumb" />
            </ng-container>

            <div *ngIf="vids.length === 0 && context.isVideoPending(msg)" class="video-progress">
              <app-bird-loader label="Thinking"></app-bird-loader>
              <span *ngIf="context.getProgress(msg) != null">{{ context.getProgress(msg) }}%</span>
            </div>

            <video
              *ngFor="let v of vids; trackBy: context.trackByMedia"
              [src]="v"
              controls
              playsinline>
            </video>
          </div>
        </ng-container>

        <div *ngIf="context.getMediaError(msg)" class="media-error">
          {{ context.getMediaError(msg) }}
        </div>

        <!-- Footer (ClariChat-style) -->
        <div class="message-footer">
          <div class="message-footer-meta">
            <span class="message-timestamp">
              {{ msg.timestamp | date: 'short' }}
            </span>
            <span class="message-meta-chip" *ngIf="msg.role === 'user'">Me</span>
            <span class="message-meta-chip" *ngIf="msg.role === 'assistant' && (msg.modelDisplayName || msg.modelId)">
              {{ msg.modelDisplayName || msg.modelId }}
            </span>
          </div>

          <div class="message-footer-actions">
            <button type="button" class="message-footer-btn" (click)="context.onActionCopy(msg, i)">
              Copy
            </button>

            <span class="actions-anchor">
              <button
                class="actions-plus-btn"
                type="button"
                (click)="context.toggleActionsMenu(msg, $event)">
                +
              </button>

              <div
                class="actions-dropdown anchored"
                *ngIf="context.isActionsMenuOpen(msg)"
                (click)="$event.stopPropagation()">

                <button type="button" class="actions-item" (click)="context.onActionPin(msg)">
                  <span class="me-2">{{ msg.pinned ? '📌' : '🔖' }}</span>
                  {{ msg.pinned ? 'Unpin' : 'Pin' }}
                </button>

                <button type="button" class="actions-item" (click)="context.onActionCopyToClariChat(msg)">
                  <i class="fa-solid fa-arrow-up-right-from-square me-2"></i>
                  Add to ClariNotes
                </button>

                <button
                  type="button"
                  class="actions-item"
                  *ngIf="context.firstVideoUrl(msg) as v"
                  (click)="context.downloadVideo(v)">
                  <i class="fa-solid fa-download me-2"></i>
                  Download video
                </button>
              </div>

              <span
                class="action-toast anchored"
                *ngIf="msg?.id && context.actionToastById[msg.id]"
                [ngClass]="context.actionToastById[msg.id].type">
                {{ context.actionToastById[msg.id].text }}
              </span>
            </span>
          </div>
        </div>
      </div>
    </ng-container>

    <app-bird-loader *ngIf="context.isLoading" label="Thinking"></app-bird-loader>
  </div>

  <!-- Composer (ClariChat-style shell) -->
  <div class="bottomcontainer">
    <div class="input-container">

      <button
        class="scroll-to-bottom-btn"
        *ngIf="context.showScrollToBottom"
        (click)="context.scrollToBottom()"
        aria-label="Scroll to bottom">
        ↓
      </button>

      <div class="composer-shell">

        <input
          #fileInput
          id="imageReferenceUpload"
          type="file"
          [attr.accept]="context.imageAccept"
          (change)="context.onFileSelected($event)"
          style="display:none">

        <div class="textarea-wrapper">

         <textarea
            #videoTextarea
            id="videoPromptInput"
            class="user-input-textarea"
            [(ngModel)]="context.userInput"
            rows="1"
            placeholder="Describe what you want to generate…"
            (keydown)="context.onKeyDown($event)"
            (input)="context.autoResize(videoTextarea)"
            [disabled]="context.audioActive"
            [class.disabled-typing]="context.audioActive">
          </textarea>

          <!-- <button
            id="micButton"
            class="btn-audio-fixed"
            type="button"
            (click)="context.onAudioIconClick()"
            matTooltip="Click to start voice">
            <img src="assets/icons/audio-wave.svg" class="audio-icon" alt="Audio" />
          </button> -->


 <div class="left-actions">
            <div class="composer-tools">
              <button
                type="button"
                class="tools-plus-btn"
                aria-label="Open tools menu"
                (click)="context.toggleComposerToolsMenu($event)">
                <span class="tools-plus-icon" aria-hidden="true">+</span>
              </button>

              <div
                class="video-generator-menu composer-tools-menu"
                *ngIf="context.showComposerToolsMenu"
                (click)="$event.stopPropagation()">

                <div class="tools-menu-section">
                  <div class="tools-menu-title">Quick Actions</div>

                  <button type="button" class="tools-menu-button" (click)="context.repeatPromptFromComposer()">
                    <span class="tools-menu-icon"><i class="fas fa-clock-rotate-left"></i></span>
                    <span class="tools-menu-label">Repeat Prompt</span>
                  </button>

                  <button type="button" class="tools-menu-button" (click)="context.openComposerAICatalog()">
                    <span class="tools-menu-icon">
                      <img src="assets/select-white.svg" class="selectai-icon" />
                    </span>
                    <span class="tools-menu-label">AI Selector</span>
                  </button>  
                  <!-- KEEP THIS INCASE WE WANT TO USE DIALOG FOR AI SELECTOR -->

                  <button type="button" class="tools-menu-button tools-menu-button-advisory" (click)="context.openComposerAdvisory()">
                    <span class="tools-menu-icon"><i class="fa fa-eye"></i></span>
                    <span class="tools-menu-label">Advisors</span>
                  </button>

                  <button
                    *ngIf="context.selectedModelName"
                    type="button"
                    class="tools-menu-button tools-menu-model-button"
                    (click)="context.openComposerModelInfo()">
                    <span class="tools-menu-icon"><i class="fas fa-info-circle"></i></span>
                    <span class="tools-menu-label">{{ context.selectedModelName }}</span>
                  </button>
                </div>

                <div class="tools-menu-section">
                  <div class="tools-menu-title">Export</div>

                  <button type="button" class="tools-menu-button" (click)="context.exportComposerPdf()">
                    <span class="tools-menu-icon">📄</span>
                    <span class="tools-menu-label">Export to PDF</span>
                  </button>

                  <button type="button" class="tools-menu-button" (click)="context.exportComposerDocx()">
                    <span class="tools-menu-icon">📝</span>
                    <span class="tools-menu-label">Export to DOCX</span>
                  </button>
                </div>
              </div>
            </div>
          </div>



           <button
  id="sendMessageButton"
  class="btn-send-fixed"
  type="button"
  (click)="context.userInput?.trim().length ? context.sendMessage() : context.onAudioIconClick()"
  [disabled]="context.isLoading"
>
  <ng-container *ngIf="context.userInput?.trim().length; else audioWaveIcon">
    <i class="fas fa-arrow-up"></i>
  </ng-container>

  <ng-template #audioWaveIcon>
    <img src="assets/icons/audio-wave.svg" class="audio-icon" alt="Audio" />
  </ng-template>
</button>


          <div class="reference-preview" *ngIf="context.referencePreviewUrl">
            <img [src]="context.referencePreviewUrl" alt="Reference image preview">
            <button type="button" class="reference-preview__clear" (click)="context.clearImage()">Remove</button>
          </div>

          <div class="reference-error" *ngIf="context.imageValidationError">{{ context.imageValidationError }}</div>

          <div class="model-grid-inside">
            <!-- Model Dropdown (paper clip + model name in same container) -->
            <div class="grid-item-inside selector" id="videoModelDropdown">
              <div class="video-model-selector video-dropdown-root">
                <!-- Paper clip: opens image file picker, only when model supports reference image -->
                <button *ngIf="context.supportsReferenceImage"
                        type="button"
                        class="elegant-btn paperclip-trigger"
                        (click)="fileInput.click(); $event.stopPropagation()"
                        aria-label="Attach image">
                  <span class="btn-icon paperclip-icon"><i class="fas fa-paperclip"></i></span>
                </button>
                <button type="button" class="elegant-btn lovesheet33" (click)="context.toggleDropdown($event)">
                  <span class="btn-icon">
                  </span>
                  <span class="btn-text">{{ selectedModel?.label }}</span>
                  <i class="fas fa-chevron-down btn-chevron" [class.rotated]="context.dropdownOpen"></i>
                </button> <!--KEEP THIS AS THIS IS ANOTHER OPTION FOR AI SELECTOR-->

                <div class="video-generator-menu video-model-popover" *ngIf="context.dropdownOpen" (click)="$event.stopPropagation()">

                  <div class="popover-header">
                    <div class="popover-title">Choose a model</div>
                    <div class="popover-sub" *ngIf="!useAccordion">Video</div>
                  </div>
                
                  <div class="popover-search">
                    <i class="fas fa-magnifying-glass"></i>
                    <input
                      type="text"
                      class="popover-search-input"
                      placeholder="Search models…"
                      (click)="$event.stopPropagation()"
                      autocomplete="off" />
                  </div>
                
                  <!-- Accordion: Video models -->
                  <div class="popover-section" *ngIf="useAccordion">
                    <button type="button" class="popover-accordion-header" (click)="toggleVideoAccordion()">
                      <i class="fas fa-chevron-right accordion-chevron" [class.accordion-open]="videoAccordionOpen"></i>
                      <span class="popover-section-title">Video</span>
                    </button>
                    <div class="popover-section-content" *ngIf="videoAccordionOpen">
                      <div class="model-card-grid">
                        <button
                          type="button"
                          class="model-card"
                          *ngFor="let model of displayVideoModels"
                          (click)="context.selectVideoModel(model.value)"
                          [class.selected]="model.value === selectedModel?.value">
                          
                          <div class="model-card-icon">
  <img class="model-icon" [src]="model.iconUrl" [alt]="model.label + ' icon'" />
</div>

                          <div class="model-card-body">
                            <div class="model-card-title">{{ model.label }}</div>
                            <div class="model-card-meta">Cinematic • Story</div>
                          </div>
                          <i *ngIf="model.value === selectedModel?.value"></i>
                        </button>
                      </div>
                    </div>
                  </div>

                  <!-- Accordion: Image models -->
                  <div class="popover-section" *ngIf="useAccordion">
                    <button type="button" class="popover-accordion-header" (click)="toggleImageAccordion()">
                      <i class="fas fa-chevron-right accordion-chevron" [class.accordion-open]="imageAccordionOpen"></i>
                      <span class="popover-section-title">Image</span>
                    </button>
                    <div class="popover-section-content" *ngIf="imageAccordionOpen">
                      <div class="model-card-grid">
                        <button
                          type="button"
                          class="model-card"
                          *ngFor="let model of displayImageModels"
                          (click)="context.selectVideoModel(model.value)"
                          [class.selected]="model.value === selectedModel?.value">

                          <div class="model-card-icon">
  <img class="model-icon" [src]="model.iconUrl" [alt]="model.label + ' icon'" />
</div>

                          <div class="model-card-body">
                            <div class="model-card-title">{{ model.label }}</div>
                            <div class="model-card-meta">High-res • Fast</div>
                          </div>
                          <i *ngIf="model.value === selectedModel?.value"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                
                  <!-- Single section (no accordion) -->
                  <div class="popover-section" *ngIf="!useAccordion">
                    <div class="popover-section-title">Video</div>
                    <div class="model-card-grid">
                      <button
                        type="button"
                        class="model-card"
                        *ngFor="let model of models"
                        (click)="context.selectVideoModel(model.value)"
                        [class.selected]="model.value === selectedModel?.value">
                        <div class="model-card-icon">{{ model.icon }}</div>
                        <div class="model-card-body">
                          <div class="model-card-title">{{ model.label }}</div>
                          <div class="model-card-meta">High-res • Fast</div>
                        </div>
                        <i *ngIf="model.value === selectedModel?.value"></i>
                      </button>
                    </div>
                  </div>
                
                </div>
                
              </div>
            </div>

            <!-- Clear image -->
            <div class="grid-item-inside selector" *ngIf="context.referencePreviewUrl">
              <button class="elegant-btn lovesheet1" (click)="context.clearImage()">
                <span class="btn-icon"><i class="fas fa-xmark"></i></span>
                <span class="btn-text">Clear</span>
              </button>
            </div>

            <!-- Tips -->
            <!-- <div class="grid-item-inside selector">
              <button class="elegant-btn lovesheet2" (click)="context.openModelInfo()">
                <span class="btn-icon"><i class="fas fa-info-circle"></i></span>
                <span class="btn-text">Model Info</span>
              </button>
            </div> -->
          </div>
        </div>
      </div>

      <!-- UI progress bar (kept) -->
      <div class="genbar" *ngIf="context.generating">
        <div class="genrow">
          <span class="videoIcon flashing">🎥</span>
          <span class="genText">Generating with {{ context.selectedModelName }}…</span>
          <span class="pct">{{ context.uiProgress }}%</span>
        </div>
        <div class="bar">
          <div class="fill" [style.width.%]="context.uiProgress"></div>
        </div>
      </div>

    </div>
  </div>
</div>
